<template>
  <div class="container">
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <el-col :lg="12" :span="24">
        <el-card>
          <ExcelTable
            title="原始文件"
            :height="tableHeight"
            tableKey="origin-data-table"
            @change="(o) => (origin = o)"
          />
        </el-card>
      </el-col>
      <el-col :lg="12" :span="24">
        <el-card>
          <ExcelTable
            title="更新文件"
            themeType="warning"
            :height="tableHeight"
            tableKey="current-data-table"
            @change="(c) => (current = c)"
          />
        </el-card>
      </el-col>
    </el-row>
    <div>
      <el-card>
        <ResultTable
          :height="tableHeight"
          :columns="tableColumns"
          :data="tableData"
          :origin="origin"
          :current="current"
        />
      </el-card>
    </div>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import ExcelTable from './components/excel-table'
import ResultTable from './components/result-table'
export default {
  name: 'preOrder-fileComparison',
  mixins: [EditLoading],
  components: { ExcelTable, ResultTable },
  data() {
    return {
      tableHeight: 500,
      tableData: [],
      tableColumns: [],
      origin: null,
      current: null,
    }
  },
  created() {
    window.addEventListener('resize', this.getHeight)
  },
  mounted() {
    this.getHeight()
  },
  destroyed() {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    getHeight() {
      const { height } = document.documentElement.getBoundingClientRect()
      const tableHeight = (height - 213) / 2
      this.tableHeight = tableHeight < 350 ? 350 : tableHeight
    },
  },
}
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  max-width: 100%;
  padding: 0;
  > .el-row {
    margin-bottom: 0 !important;
    .el-col {
      margin-bottom: 20px !important;
    }
  }
}
</style>
